<div class="ddp-ui-chart-side ddp-show">
  <div class="ddp-ui-side-title">
    {{ 'msg.page.ui.number.format.title' | translate }}
  </div>
  <div class="ddp-wrap-downmenu">
    <div class="ddp-box-down" format-item #commonFormat (changeFormat)="onChange($event)" [format]="format"></div>
  </div>
</div>
